export default __webpack_public_path__ + "132ac0743cea8105437b8ba42e107caa.svg";